module.exports = __webpack_public_path__ + "static/media/funding-landscape.c7ce0173.svg";